import { ReactChild } from 'react';
import styles from '../styles/createTableTooltip.module.scss';
import Tooltip from '@ui-kit/components/tooltip';

export const CreateTableTooltip = (props: { children: string | ReactChild }) => {
  return (
    <Tooltip overlay={props.children} trigger="hover" placement="bottomRight">
      <div className={styles.tooltip}>?</div>
    </Tooltip>
  );
};
